import React, { useState } from "react";
import { Spinner } from "react-bootstrap";

const Feedback = () => {
  const [pageLoader, setPageLoader] = useState(true);

  const handleIframeLoad = () => {
    setPageLoader(false);
  };

  return (
    <div className="w-100 h-100 ">
      <h4 className="text-center mt-3 mb-4">Please Provide Your Feedback</h4>
      {pageLoader && (
        <div className="d-flex justify-content-center">
          <Spinner animation="border" variant="primary" />
        </div>
      )}
      <div
        className="w-100"
        style={{ maxHeight: "80%", height: "100%" }}
      >
        <iframe
          src="https://connect.sjinnovation.us/widget/form/h9QBb9GfmfhZ5IOULXPX"
          onLoad={handleIframeLoad}
          style={{ width: "100%", height: "100%" }}
          data-layout="{'id':'INLINE'}"
          data-trigger-type="alwaysShow"
          data-trigger-value=""
          data-activation-type="alwaysActivated"
          data-activation-value=""
          data-deactivation-type="neverDeactivate"
          data-deactivation-value=""
          data-form-name="AiBidAssist Feedback"
          data-height="1379"
          data-layout-iframe-id="inline-h9QBb9GfmfhZ5IOULXPX"
          data-form-id="h9QBb9GfmfhZ5IOULXPX"
        ></iframe>
        <script src="https://connect.sjinnovation.us/js/form_embed.js"></script>
      </div>
    </div>
  );
};

export default Feedback;